import { createContext, useContext } from 'react';
import DEFAULT_STRINGS from '../constants/strings.en-US';

export const StringsContext = createContext(DEFAULT_STRINGS);

export function useStrings() {
    const strings = useContext(StringsContext);

    return strings;
}